/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Include_UpdatedInputs */

const en_dialog_include_updated = /** @type {(inputs: Dialog_Include_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Updated at`)
};

const es_dialog_include_updated = /** @type {(inputs: Dialog_Include_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir fecha de actualización`)
};

/**
* | output |
* | --- |
* | "Include Updated at" |
*
* @param {Dialog_Include_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_include_updated = /** @type {((inputs?: Dialog_Include_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Include_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_include_updated(inputs)
	return en_dialog_include_updated(inputs)
});